import {createTheme} from '@mui/material/styles';

export const theme=({userData,roleConfig})=>{
  const mainColor=roleConfig?.main_color||'#808080';
  const listLinkColor=roleConfig?.list_link_color||'#D3D3D3';
  const theme=createTheme({
    palette:{
      primary:{
        main:mainColor,
      },
    },
    list_link_color:listLinkColor,
    components:{
      MuiButton:{
        defaultProps:{
          sx:{
            fontSize:'0.78rem',
            paddingLeft:'5px',
            paddingRight:'5px',
            paddingTop:'0',
            paddingBottom:'0',
          },
        },
      },
    },
  });
  return theme
}

export default theme;